import { topicDetailsActionTypes } from './Constants';

const initialState = {
	loading: true,
	topicDetails: {},
	loadingRelatedQuestions: false,
	relatedQuestions: {
		results: [],
		total_count: null,
	},
};

export default function topicDetailsReducer(state = initialState, action) {
	const { type, payload } = action;
	const { topicDetails, data } = payload || {};

	switch (type) {
		case topicDetailsActionTypes.GET_TOPIC_DETAILS:
			return {
				...state,
				loading: true,
			};
		case topicDetailsActionTypes.GET_TOPIC_DETAILS_SUCCESS:
			return {
				...state,
				topicDetails,
				loading: false,
			};
		case topicDetailsActionTypes.GET_TOPIC_DETAILS_ERROR:
			return {
				...state,
				loading: false,
			};
		case topicDetailsActionTypes.GET_TOPIC_RELATED_QUESTIONS:
			return {
				...state,
				loadingRelatedQuestions: true,
			};
		case topicDetailsActionTypes.GET_TOPIC_RELATED_QUESTIONS_SUCCESS:
			return {
				...state,
				loadingRelatedQuestions: false,
				relatedQuestions: data,
			};
		case topicDetailsActionTypes.GET_TOPIC_RELATED_QUESTIONS_ERROR:
			return {
				...state,
				loadingRelatedQuestions: false,
			};

		case topicDetailsActionTypes.CLEAN_TOPIC_DETAILS_STATE:
			return initialState;

		default:
			return state;
	}
}
